import React, { useState, useRef, useEffect } from 'react';
import cx from 'classnames';
import PersonIcon from '@mui/icons-material/Person';
import IB_LOGO from 'assets/icons/ib-logo.svg';

import styles from './header.module.scss';

function Header({ name, role, roles, onRoleSwitch,onSignOut }) {
    const [open, setOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        window.addEventListener('click', handleOutsideClick);
    }, []);

    function handleOutsideClick(e) {
        if (!menuRef?.current.contains(e.target)) {
            setOpen(false);
        }
    }

    function handleProfileClick(e) {
        e.stopPropagation();
        setOpen((toggle) => !toggle);
    }

    return (
        <div className={styles.wrapper}>
            <img className={styles.logo} src={IB_LOGO} alt="ib-logo" />
            <div className={styles.profile}>
                <p className={styles.name}>{name}</p>
                <div className={styles.image} onClick={handleProfileClick}>
                    <PersonIcon />
                </div>
                <div className={styles.menuWrapper} ref={menuRef}>
                    <div className={cx(styles.menu, { [styles.close]: !open })}>
                        {roles.map((el,index) => (
                            <p
                                key={index}
                                className={cx(styles.menuItem, {
                                    [styles.active]: role === el
                                })}
                                onClick={() => {
                                    role !== el && onRoleSwitch(el);
                                    setOpen(false);
                                }}
                            >
                                Switch as {el}
                            </p>

                        ))}
                            <p
                                    className={(styles.menuItem)}
                                    onClick={onSignOut}>
                                    Sign Out
                            </p>
                    </div>
                </div>
            </div>
            {/* <Menu
                id="profile-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                className={styles.menu}
                PopoverClasses={profileMenuSx}
                PaperProps={{
                    elevation: 0,
                    sx: profileMenuSx
                }}
                transformOrigin={{
                    horizontal: 'right',
                    vertical: 'top'
                }}
                anchorOrigin={{
                    horizontal: 'right',
                    vertical: 'bottom'
                }}
            >
                {roles.map((el) => (
                    <MenuItem
                        onClick={() => onRoleSwitch(el)}
                        selected={el === role}
                    >
                        Switch as {el}
                    </MenuItem>
                ))}
            </Menu> */}
        </div>
    );
}

export default Header;
